<m1-auth-layout
  [title]="Labels().title"
  [description]="Labels().description"
  [copyrightLabel]="copyrightLabel()"
  [communicativeImg]="communicativeImg"
>
  <m1-disclaimer></m1-disclaimer>
  <div class="cb-register-form" [formGroup]="registerForm">
    <m1-input
      inputId="1"
      [minLength]="2"
      [maxLength]="150"
      [formControl]="username"
      [label]="Labels().username"
      [hideSupportText]="false"
      [readonly]="readonly"
      [shouldShowAsterisk]="true"
    ></m1-input>

    <m1-input
      inputId="2"
      [maxLength]="320"
      [formControl]="email"
      [label]="Labels().email"
      [hideSupportText]="false"
      [readonly]="readonly"
      [shouldShowAsterisk]="true"
    ></m1-input>

    <m1-input
      inputId="3"
      [formControl]="passwordControl"
      [hideSupportText]="false"
      [label]="Labels().password"
      [readonly]="readonly"
      [passwordInput]="true"
      [shouldShowAsterisk]="true"
      (blur)="onConfirmPasswordBlur()"
    ></m1-input>

    <m1-input
      inputId="4"
      [formControl]="confirmPasswordControl"
      [label]="Labels().confirmPassword"
      [hideSupportText]="false"
      [readonly]="readonly"
      [passwordInput]="true"
      [shouldShowAsterisk]="true"
      (blur)="onConfirmPasswordBlur()"
    ></m1-input>

    <m1-password-checklist
      [errors]="registerForm.errors"
      [dirty]="registerForm.dirty"
      [description]="Labels().passwordCheckList"
      [errorMessages]="passwordErrorMessages"
    ></m1-password-checklist>

    <button
      type="submit"
      m1-primary-button
      [disabled]="!isFormValid || readonly"
      [loading]="isloading"
      (click)="register()"
    >
    <span> {{Labels().button}}</span>
  </button>

  </div>
  <p class="support">{{ Labels().support }}</p>
</m1-auth-layout>


